import React from "react"
import autobind from "class-autobind"
import AccountStore from "../../../stores/AccountStore"
import { IPosition } from "../../../models"
import Positions from "../../../components/position/Positions"
import * as accountActions from "../../../actions/AccountActions"
interface IProps {

}
interface IState {
    positions: IPosition[]
}

export default class AccountPositions extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        const positionDefinitions = AccountStore.getCurrentAccount().PositionDefinitions || []
        this.state = {
            positions: positionDefinitions
        }
        autobind(this)
    }

    componentDidMount() {
        AccountStore.on("account_change", this.accountChangeEvent)
    }

    componentWillUnmount() {
        AccountStore.removeListener("account_change", this.accountChangeEvent)
    }

    accountChangeEvent() {
        this.setState({ positions: AccountStore.getCurrentAccount().PositionDefinitions || [] })
    }

    render() {
        return (
            <Positions
                isDefinition
                hideTableActionBarTitle
                addButtonRight={0}
                addButtonTop={-90}
                positions={this.state.positions}
                usablePositions={this.state.positions}
                handleAdd={(position, cb) =>
                    accountActions.addPositionDefinition(AccountStore.getCurrentAccount().Id, position, cb)
                }
                handleUpdate={(position, cb) =>
                    accountActions.updatePositionDefinition(AccountStore.getCurrentAccount().Id, position, cb)
                }
                handleDelete={(positions, cb) =>
                    accountActions.deletePositions(AccountStore.getCurrentAccount().Id, positions, cb)
                }
            />
        )
    }
}
